import React, { useEffect } from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import useBreakerGallery from 'hooks/useBreakerGallery';
import Footer from '../Footer/Footer';
import BreakerCard from './BreakerCard';
import Filters from './Filters';
import ActiveFilters from './ActiveFilters';

import SVG from 'react-inlinesvg';
import { allsvg } from '../../utils/allsvg.js';

import './Gallery.scss';
import BreakerModal from './BreakerModal';
import useBreakerModal from 'hooks/useBreakerModal';

export const OldGallery = () => {
  const {
    isLoading,
    breakers,
    activeFilters,
    attributeMap,
    setFilter,
    removeFilter,
    clearFilters,
    loadMore,
    count,
    getBreakerById,
  } = useBreakerGallery();

  const { setId, clearId, selectedBreakerId } = useBreakerModal();

  useEffect(() => {
    const offcanvasBackdrop = document.querySelector('.offcanvas-backdrop');
    // The backdrop does not close manually on mobile, so we have to do it
    // manually here. We do not have access to the bootstrap global object
    // so we must manually click the dusknav to dismiss it.
    if (offcanvasBackdrop && offcanvasBackdrop.classList.contains('show')) {
      (document.querySelector('button[data-bs-target="#dusknav"]') as HTMLElement)?.click();
    }
  }, []);

  if (!breakers || isLoading) {
    return null;
  }

  const selectedBreaker = getBreakerById(selectedBreakerId);

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="gallery"
    >
      <Helmet>
        <title>Gallery - DuskBreakers</title>
        <meta
          name="description"
          content="Explore the universe of DuskBreakers and learn more about life as a Breaker."
        />
      </Helmet>
      <section className="breakerGallery">
        <div className="container">
          <div className="row">
            <div className="col">
              <h1>Gallery</h1>
            </div>
          </div>
          <div className="row d-flex">
            <nav className="col-lg-3 pt-0 pb-3 navbar navbar-expand-lg">
              <button
                id="filter"
                className="d-block d-lg-none btn btn-sm btn-outline-secondary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#filterOffcanvasLg"
                aria-controls="filterOffcanvasLg"
              >
                <SVG className="ui-icon" src={allsvg.filter_icon} />
                <span>Filter</span>
              </button>
              <div
                className="offcanvas offcanvas-end"
                id="filterOffcanvasLg"
                aria-labelledby="filterOffcanvasLgLabel"
              >
                <Filters
                  activeFilters={activeFilters}
                  attributeMap={attributeMap}
                  setFilter={setFilter}
                  removeFilter={removeFilter}
                />
              </div>
            </nav>

            <div className="col">
              <div className="row d-flex g-4">
                <div className="breaker-count text-bold">{`${count} breakers`}</div>
                <ActiveFilters
                  activeFilters={activeFilters}
                  removeFilter={removeFilter}
                  clearFilters={clearFilters}
                />

                {breakers.map((breaker, i) => {
                  return (
                    <div className="col-6 col-lg-3" key={`${breaker.name}-${i}`}>
                      <BreakerCard breaker={breaker} setSelectedBreaker={setId} />
                    </div>
                  );
                })}

                {loadMore && (
                  <button className="btn" onClick={loadMore}>
                    LOAD MORE
                  </button>
                )}
              </div>
            </div>

            {selectedBreaker && <BreakerModal breaker={selectedBreaker} onClose={clearId} />}
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
};
